import * as yup from 'yup';

export const RelativeMandateSchema = yup.object({
  description: yup.string().required(),
  expiryDate: yup.date().notRequired().nullable(),
});

export interface IRelativeMandate {
  description: string;
  expiryDate: Date;
}

export const UpdateRelativeMandateSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(RelativeMandateSchema);

export interface IUpdateRelativeMandate extends IRelativeMandate {
  id: string;
}
